module.exports = __webpack_public_path__ + "static/img/11.50df7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11.png
// module id = RKxq
// module chunks = 3